import { SupportEmail } from "./enum";

export const PortugeseTranslations = {
  logintitle: "Bem-vindo de volta! Venha combater o Desperdício Alimentar",
  registerTitle: "Venha combater o Desperdício Alimentar",
  loginbutton: "Entrar",
  loginDescription:
    "Qui tempore quidem nulla pariatur aut enim sapiente. Modi erroromnis. Ex deserunt ut aperiam amet quas iste et non. Aceder",
  authOptions: "Acesso alternativo",
  rememberMe: "Mantenha-me conectado",
  forgotPassword: "Recuperar acesso",
  dontHaveAccount: "Ainda não está registado?",
  createAccount: "Criar conta",
  password: "Palavra-passe",
  confirmPassword: "Confirmar palavra-passe",
  haveAccount: "Já tem uma conta?",
  loginWith: "Entre com a sua conta",
  profile: "Perfil",
  activity: "Atividade",
  entityType: "Tipo utilizador",
  entityData: "Dados da entidade",
  platform: "Plataforma",
  cancel: "Cancelar",
  approve: "Confirmar reserva",
  profileQuestion: "Como pretende utilizar a plataforma?",
  activityQuestion: "A que área de atividade pertence?",
  entityTypeQuestion: "Como carateriza a sua entidade?",
  entityDataQuestion: "Identificação da sua entidade",
  platformQuestion: "Não fique de fora, fique a par de tudo",
  platformNotification: "Notificações da plataforma (recomendado)",
  platformNotificationSub: "Receba informações de atividade automaticamente na plataforma",
  platformUserMessage: "Notificações por e-mail",
  platformUserMessageSub: "Receba comunicações de operações realizadas na plataforma",
  platformDescription:
    "Pode alterar estas opções mais tarde, acedendo à sua página de perfil.",
  platformConfirmation: "Confirmo que li e aceito os",
  termsAndConditions: "Termos e condições",
  donor: "Quero doar",
  distributor: "Quero receber",
  donorDistributor: "Quero doar e receber",
  SubTitleSpecialDist : "Para alimentação animal...Quero receber produtos de doações que não foram reservadas – Todos os produtos inseridos na Plataforma que não foram reservados e atingiram a validade final do ticket, podem ser encaminhados para alimentação animal. Caso seja uma entidade com a missão / na área de proteção / cuidado de animais e pretenda receber doações de produtos que não tiveram procura para a vertente de consumo humano, inscreva-se aqui.",
  feedBank: "Banco Alimentar",
  horecaChannel: "Canal HORECA",
  publicEntities: "Municípios / Juntas de Freguesia",
  industry: "Indústria",
  ipss: "IPSS",
  eventOrganization: "Organização de Eventos",
  production: "Produção",
  retailer: "Retalho",
  other: "Outro",
  otherReceiver: "Outras Entidades com fins sociais",
  groupUnitManangement: "Sou uma entidade com vários estabelecimentos",
  store: "Sou apenas um estabelecimento",
  register: "Registar",
  emailRequired: "E-mail é obrigatório",
  passwordRequired: "Palavra-passe é obrigatória",
  pleaseRetypePassword: "Por favor, reescreva a palavra-passe",
  passwordDonotMatch: "Palavras-passe não correspondem",
  newDonation: "Nova Doação",
  history: "Histórico",
  actions: "Agenda",
  home: "Início",
  code: "Código de doação",
  messages: "Mensagens",
  Messages: "Mensagens",
  Articles: "Artigos",
  Details: "Detalhes",
  settings: "Definições",
  createDonationHeading: "O que vamos doar hoje?",
  fightWaste: "Quero combater o desperdício!",
  donate: "Doar",
  donateDescription: "Quero combater o desperdício!",
  insertBySearch: "Inserir por pesquisa",
  insertByBatch: "Inserir por categoria",
  search: "Pesquisar",
  needHelpWithProcess: "Precisa de ajuda em algum processo?",
  clickToTour: "Perguntas frequentes",
  commonQuestions: "Perguntas frequentes",
  messageAndNotification: "Mensagens",
  alertAndNotification: "Alertas e Notificações",
  donationAvailable: "Doações disponíveis",
  scheduleAction: "Ações agendadas",
  donationDelivered: "Doações entregues",
  simpleStatThisMonth: "Estatística simples",
  myOngoingDonations: "As minhas doações em curso",
  seeAll: "Ver todas",
  myActivitySummary: "O meu resumo de atividade",
  myActivitySummarySub: "Breve resumo das doações colocadas na plataforma",
  myAlerts: "Os meus alertas",
  myAlertsSub: "Últimas interações",
  selectTypeOfDonation: "Selecione o tipo de doação a realizar",
  event: "Evento",
  product: "Produtos",
  collection: "Recolha",
  boxes: "Caixas",
  unread: "nao lida",
  comments: "observações",
  collectionperiod: "Local de recolha",
  //byNishad
  houseHold: "Morada",
  name: "Nome",
  district: "Distrito",
  county: "Concelho",
  parshi: "Freguesia",
  contacts: "Outros contatos",
  contact: "Contato",
  postcard: "C. Postal",
  locality: "Localidade",
  continue: "Continuar",
  postalCode: "Código postal",

  // ------------------------------
  // Abhimanyu
  wrongPassOrEmailMsg: "E-mail ou Senha Incorreto",
  emailAddress: "Endereço de e-mail",
  emailForAddress:"Endereço de e-mail",
  createDonationAddressHeading: "Local de entrega",
  myAddress: "As minhas moradas",
  otherAddresses: "Outra morada",
  mobile: "Contato telefónico",
  designation: "Cargo/Função",
  readyMeals: "Refeições prontas",
  fresh: "Frescos",
  praesentiumWhenIRelease: "praesentium quam libero",
  quisVelitCorporisIlloPorroPossimusVoluptasQuasiTenetur:
    "Quis velit corporis illo porro possimus voluptas quasi tenetur",
  veroWantedPraesentiumLabore: "Vero quis praesentium labore ",
  addBranch: "Adicionar Estabelecimento",
  manageBranches: "Estabelecimentos",
  //------------------------------
  // Parminder
  loginSuccess: "Conectado com sucesso!",
  finalize: "Finalizar",
  addressTitle: "Designação",
  contactName: "Nome de contato",
  phone: "Contato telefónico",
  email: "E-mail",
  address: "Endereço",
  addProduct: "Adicionar",
  //unit
  box: "Embalagens",
  //dozen: "Dúzias",
  unidades: "Unidades",
  kg: "Quilograma",
  kl: "kl",
  litros: "Litros",
  pieces: "Peças",
  doses: "Doses",



  //
  upComingCollection: "Próximas recolhas",
  collectionOfScheduledDonations: "Recolha de doações agendadas",
  donations: "Doações",
  available: "disponíveis",
  quantityIsRequired: "A quantidade é obrigatória",
  accept: "Aceitar",
  acceptedQuantity: "Qtd: aceito",
  collectionDate: "Data de recolha",
  //
  requestStatus: "Estado do registo",
  requestInActiveStatus:"Conta desativada",
  rejectModalContent: `A sua solicitação de registo foi rejeitada. Entre em contacto com o suporte em ${SupportEmail} para qualquer dúvida.`,
  pendingModalContent: `O seu pedido foi registado e encontra-se em análise. Para qualquer esclarecimento, entre em contacto connosco através do endereço:  ${SupportEmail}.`,
  inActiveModalContent: `Sua conta foi desativada pelo administrador. Para qualquer esclarecimento, contacte-nos para: ${SupportEmail}. Não vai poder criar novos registos, apenas será possível cancelar/confirmar recolha dos registos ativos`,
  revokedModalContent: `O Seu registo foi desativado. Para qualquer esclarecimento, entre em contacto connosco através do endereço: ${SupportEmail}`,
  pendingEmailVerificationContent:
    `O seu e-mail ainda não foi confirmado. Por favor confirme a sua caixa de correio.Para qualquer esclarecimento, entre em contacto connosco através do endereço: ${SupportEmail}`,
  resetYourPassword: "Recuperar acesso",
  enterNewPassword: "Insira a palavra-passe",
  confirmNewPasssword: "Confirmar palavra-passe",
  passwordChanged: "Palavra-passe alterada com sucesso",
  passwordSuccessfullyChange: "Parabéns! A sua palavra-passe foi alterada com sucesso.",
  goToHome: "Voltar ao início",
  enterRegisteredEmail:
    "Digite seu endereço de e-mail registado e enviaremos um link de redefinição de palavra-passe",
  enterYourEmail: "Insira o seu endereço de e-mail",
  sendPasswordResetEmail: "Enviar e-mail de recuperação de acesso",
  resetPasswordLinkMessage:
    "Enviámos um e-mail com instruções de recuperação de acesso.",
  accountVerficationSuccessful:
    "Parabéns! A sua conta foi verificada com sucesso. Será notificado após aprovação do administrador da plataforma.",
  organizations: "Entidades",
  hello: "Olá",
  entity: "Entidade",
  profileOptions: "Perfil",
  primaryAddress: "Endereço principal",
  contactDetail: "Contato principal",
  pleaseEnterTheRegisteredEmail: "Por favor, digite o e-mail registado",
  pendingApplication: "Candidaturas pendentes",
  allOrganizations: "Todas entidades",
  totalDonations: "Doações",
  totalCollections: "Recolhas",
  companyType: "Tipo de companhia",
  lastActiveDate: "Última data ativa",
  noOfChild: "Estabelecimentos",
  id: "Identidade",
  action: "Agenda",
  dateOfApplication: "Data da aplicação",
  branchName: "nome da filial",
  save: "Guardar",
  emailAlreadyExist: "E-mail já existe",
  manageManagers: "Utilizadores",
  registrationSuccessfulMessage1:
    "Obrigado por se juntar à nossa iniciativa de combate ao desperdício alimentar! Enviámos um e-mail para",
  registrationSuccessfulMessage2: " com um link para confirmar o seu registo.",
  noBranches: "Ainda não tem estabelecimentos. Clique em Adicionar Estabelecimento.",
  inviteManagerEmail: "E-mail de utilizador",
  branchAddedSuccessfulMessage: "Estabelecimento adicionado com sucesso",
  invite: "Convidar",
  inviteManager: "Convidar utilizador",
  status: "Estado",
  edit: "Editar",
  editPrimaryContact: "Editar contato principal",
  contactDetailSuccessfullyUpdated:
    "Detalhes de contato atualizados com sucesso",
  someThingWentWrong: "Algo deu errado, tente novamente mais tarde",
  addAddress: "Adicionar endereço",
  noAddressToShow: "Nenhum endereço para mostrar.",
  addresses: "Outros endereços",
  addContact: "Adicionar contato",
  noContactToShow: "Nenhum contato para mostrar",
  setYourPassword: "Defina uma palavra-passe",
  passwordSuccessfullySave: "Senha salva com sucesso",
  accountAlreadyRegistered:
    "Este e-mail já foi registado na plataforma. Faça login com o mesmo.",
  successfullyApproved: "A entidade foi aprovada com sucesso",
  successfullyActivated: "Entidade reativada com sucesso",
  somethingWentWrong:
    "Não foi possível realizar a operação. Por favor, tente mais tarde.",
  successfullyRejected: "Entidade rejeitada com sucesso",
  successfullyDeactivated: "Entidade desativada com sucesso.",
  successfullyRevoked: "Utilizador desativado com sucesso",
  successfullyEstablishmentoActivated:
    "O estabelecimento foi ativado com sucesso",
  successfullyEstablishmentoDeactivated:
    "Estabelecimento desativado com sucesso",
  unableToUpdateAddress:
    "Não foi possível atualizar o endereço da entidade. Tente novamente mais tarde.",
  successfullyUpdateAddress: "Endereço atualizado com sucesso.",
  successfullyAddedAddress: "Endereço adicionado com sucesso.",
  inviteSentSuccessfully: "Convite enviado com sucesso.",
  failedToUpdateDonation: "Falha ao criar a doação.",
  donationCreatedSuccessfully: "Doação criada com sucesso.",
  addContactSuccessfully: "Contato adicionado com sucesso",
  successfullyReActive: "Utilizadore reativado com sucesso.",
  businessRegistration: "Registo comercial",
  BUSINESS_REGISTRATION: "Registo comercial",
  mandatedStatement: "Declaração mandatada",
  MANDATED_STATEMENT: "Declaração mandatada",
  document: "Documentos",
  fileUploaded: "arquivo carregado",
  profileDetails: "Detalhes de perfil",
  registrationEmail: "E-mail de registo",
  addressEmail: "Endereço de E-mail",
  otherDetails: "Outros detalhes",
  actionTakenOn: "Ação tomada em",
  actionTakenBy: "Ação tomada por",
  deactivate: "Desativar",
  activate: "Ativar",
  approved: "Aprovar",
  rejected: "Rejeitar",
  pendingEmailVerification: "Verificação de e-mail pendente",
  pendingApproval: "Aprovação pendente",
  active: "Ativa",
  inActive: "Desativar",

  child: "filha",
  selectAddress:
    "Selecione a morada e a data de recolha, para criar o doação",
  collectionCharacteristics: "Características da recolha",
  dateCollection: "Data recolha",
  benificiaryEntity: "Entidades Beneficiárias",
  remarks: "Observações",
  restaurants: "Restauração",
  hotel: "Hotelaria",
  catering: "Catering",
  type: "Tipo",
  groupEntity: "Caracterização",
  group: "Grupo",
  singleEstablisment: "Estabelecimento",
  viewDetails: "Ver detalhes",
  confirmationRejectContent:
    "De certeza que pretende rejeitar a inscrição desta entidade?",
  confirmationDeactivateContent:
    "De certeza que pretende desativar esta entidade? Se decidir proceder os utilizadores desta entidade também serão suspensos",

  confirm: "Confirmar",
  startDate: "Data de início",
  endDate: "Data final",
  confirmRevokeUser: "De certeza que pretende desativar este utilizador",
  revoked: "Desativar",
  SENT: "Enviado",
  ACCEPTED: "Aceite",
  INVITED: "Convidado",
  confirmationClearCart:
    "Tem a certeza que pretende limpar toda a lista de doação?",
  eventSub: "Doação especial (ex.: Casamentos, Festas, etc)",
  in: "de",
  until: "até",
  observations: "observações",
  withdrawalDate: "data de levantamento",
  youAreHere: "Você está aqui",
  selectYourPosition: "Por favor, marque sua localização no mapa é obrigatório",
  getMyCurrentLocation: "Obter minha localização atual",
  direction: "direções",
  category: "Categoria",
  filter: "Filtro",
  toSave: "Guardar",
  collected: "Recolhido",
  cancelCollectionDialogTitle:
    "Tem a certeza que deseja cancelar esta doação?",
  evaluateDonation: "Avaliar doação",
  collectionCancelSuccess: "Reserva cancelada com sucesso.",
  donationCancelledSuccessfully: "Doação cancelada com sucesso.",
  donationCollectedSuccessfully: "Doação recolhida com sucesso.",
  cancelDontaionDialogTitle: "Tem a certeza que deseja cancelar esta doação?",
  orderBy: "Ordenar por",
  list: "Listar",
  nearest: "Mais próximo",
  nearestExpiry: "Fim de validade do ticket mais próximo",
  donationDonorSubHeading: "Consulta de ofertas",
  donationReceiverSubHeading: "Consulte as ofertas disponíveis",
  distance: "Distância",
  toSee: "VER",
  all: "Todas",
  onlyFaviorate: "Apenas favoritos",
  onlyAssigned: "Apenas atribuidos",
  proximityOffers: "PROXIMIDADE DE OFERTAS",
  offerDistance: "Distância da oferta",
  location: "Localização",
  setDistance: "Defina a distância (Kms do ponto de registo)",
  selectLocation: "Selecione a localização",
  selectProductError: "Por favor, adicione produtos",
  selectAddressError: "Por favor, selecione o endereço",
  noOfReservation: "Nº de reservas",
  myDonation: "As minhas doações",
  actives: "Sem reservas",
  reserved: "Com reservas",
  donationExpireToday: `doações vão expirar no dia de hoje (clique em "Ordenar por" e de seguida "Fim de validade do ticket mais próximo")`,
  loading: "O Carregamento...",
  collectionCollectedSuccess: "Reserva recolhida com sucesso",
  collectionFeedbackSuccessfully: "Feedback enviado com sucesso",
  expired: "Expirado",
  profileSelectorHeading: "Entidade híbrida",
  profileSelectorSubHeading: "Selecione como pretende trabalhar na plataforma",
  profileDonor: "Doador",
  profileHibrid: "Doador e Recetor",
  profileDistributor: "Recetor",
  profileCA: "Canal alternativo",
  notificationFaviorateArtigoHeading: "Artigos favoritos",
  notificationFaviorateArtigoSubHeading:
    "Defina os tipos de artigos que mais lhe interessam",
  notificationFaviorateProximityHeading: "Notificações de proximidade",
  notificationFaviorateProximitySubHeading:
    "Defina quando será alertado consoante o local de entrega",
  noUpcomingCollections: "Nenhuma doação agendada",
  ongoingDonations: "Doações em curso",
  collectionSelectionProductError:
    "A seleção não pode exceder a quantidade disponível",
  validDate: "Selecione a data válida",
  selectDate: "Selecione a data de recolha",
  collectionSelectProductError: "Selecione pelo menos um artigo para reservar",
  unreadMessages: "Mensagens não lidas",
  today: "Hoje",
  yesterday: "Ontem",
  read: "Lida",
  unRead: "Não-lida",
  lastMessageReceived: "última mensagem recebida a ",
  noChat: "Não há mensagens de momento.",
  sendMessage: "Enviar mensagem",
  writeYourMessage: "Escreva  a sua  mensagem",
  period: "Período",
  reservation: "Reservas",
  donationId: "ID",
  to: "a",
  pickupLocation: "Local de recolha",
  noCollectionForThisDonation: "Não há reservas para esta doação.",
  noProductForThisDonation: "Esta é uma doação de evento e não tem produtos definidos pelo doador.",
  cancelled: "Cancelado",
  reservationCode: "Código de reserva",
  sweetDrop: "Pingo Doce",
  emptyCart: "Parece que a tua caixa ainda está vazia",
  toGoBack: "Voltar",
  listOfItem: "Lista de artigos a doar",
  noRecordAvailable: "Sem resultados disponíveis",
  agendaArticles1: "Este agendamento tem ",
  agendaArticles2: "artigo para recolha",
  noUpComingDistributorCollection: "Nenhuma recolha agendada",
  collectionHistory: "Histórico de recolhas",
  toMyrecentCollection: "As minhas recolhas recentes",
  noCollectionHistory: "Sem histórico de recolhas",
  viewMore: "Ver mais",
  schedules: "Agendamentos",
  alreadyVerifiedEmail: "Este e-mail já foi verificado",
  collections: "Reservas",
  notifications: "Notificações",
  noNotifications: "Você não tem Notificações",
  unreadNotifications: "Notificações não lidas",
  cancelMotive: "Cancelar Motivo",
  collectionDoanationLoadingPhrase: "Aguarde. A carregar doações",
  subHeadingDonationDashboard: "Resumo das reservas mais recentes",
  feedback: "opinião",
  settingUpdatedSuccessfully: "Definições atualizadas com sucesso",
  offers: "Ofertas",
  offerSubheading1: "Existem mais",
  offerSubheading2: "ofertas disponiveis,clique abaixo para ver todas",
  seeAllOffers: "Ver todas ofertas",
  adminEntitiesLoadingPhrase: "Aguarde. A carregar entidades",
  imageUpdate: "Imagem enviada com sucesso",
  searchID: "Pesquisar ID",
  documentType: "Tipo de documento",
  documentName: "Link do Documento",
  expiryDate: "Data de validade",
  WAITING_FOR_VALIDATION: "Aguarda validação",
  EXPIRED: "Expirado",
  INVALID: "Inválido/Não aceite",
  VALID: "Válido",
  nameEstablishment: "Nome do estabelecimento",
  documentUploadSuccessfully: "Documento(s) carregado(s) com sucesso",
  upload: "Atualizar documentos",
  upload2: "Selecionar",
  mapInfo:
    "Localização aproximada. Ajuste o marcador no mapa",
  viewDocument: "Ver documento",
  documentValidSuccessfully: "Documento validado com sucesso",
  documentRejectedSuccessfully: "Documento rejeitado com sucesso",
  confirmInvalidDocument: "De certeza que pretende invalidar este documento?",
  specialDistributor:
    "Quero receber produtos de doações que não foram reservadas – Para alimentação animal...",
  specialDistributorBody:
    "Todos os produtos inseridos na Plataforma que não foram reservados e atingiram a validade final do ticket, podem ser encaminhados para alimentação animal. Caso seja uma entidade com a missão / na área de proteção / cuidado de animais e pretenda receber doações de produtos que não tiveram procura para a vertente de consumo humano, inscreva-se aqui.",
  alernativeTexTitle: "Alimentação animal",
    zoo: "Zoológico",
  ZOO: "Zoológico",
  kennel: "Canil / Gatil",
  KENNEL_CATTERY: "Canil / Gatil",
  delete: "Apagar",
  deleteAddressContent: "Tem a certeza que pretende apagar a morada ?",
  activeDonorAddress: "Não pode apagar esta morada, existem doações em curso",
  activeReceiverAddress:
    "Não pode apagar esta morada, existem doações em curso",
  successfullyAddressDeleted: "seu morada excluído com sucesso",
  alternativeAnimalChannel: "Permitir canal alternativo",
  invalidDate: "Data Inválida",
  activeAltenativeCanal: "Sem reservas canal alternativo",
  reservedAltenativeCanal: "Com reservas canal alternativo",
  alternativeChannelEndDate: "Canal Alternativo Data final",
  permitted: "Permitir",
  notPermitted: "Não",
  alternativeChannelHabilito: "Canal Alternativo",
  offerAvialable: "Ativas",
  offerEnable: "Habilitadas",
  entityFavorite: "Entidades beneficiárias favoritas",
  noEntites: "Nenhuma entidade selecionada",
  typeToSearch: "Escreva para pesquisar...",
  consult: "Consultar",
  donationNotAviableForExcludedEntities:
  //"Entidades excluídas para esta doação",
    "Doação não disponível para entidades excluídas",
  excludedEntites: "Entidades excluídas",
  noExcludedEntites: "Nenhuma entidade excluÍda",
  REGISTERING: "A registar",
  PENDING_EMAIL_VERIFICATION: "Verificação de e-mail pendente",
  PENDING_APPROVAL: "Aprovação pendente",
  REJECTED: "Rejeitado",
  ACTIVE: "Ativo",
  IN_ACTIVE: "Inativo",
  REVOKED: "Revogado",
  disative: "desativado",
  statusInActiveInfo:"Esta entidade foi desativada.",
  statusRejectorInfo:"Esta entidade foi rejeitada.",
  noOptionsText:"Sem opções",
  parentEntityNoDonation:"Os seus estabelecimentos ainda não tem doações",
  childEntityNoDonation:"Ainda não tem doações. Clique em Nova doação para começar",
  inviteManagerSuccess:"Utilizador convidado com sucesso",
  errorMessage:"Preencha os campos necessários",
  companyName:"Nome",
  loginConfirm:"Confirmar",
  accountDisabled:"Conta desativada. Contate o seu gestor.",

   /// notificacoes por mensagem 
   isFimDoacao: "Fim de doação",
   isNovaMensagem: "Nova mensagem",
   isNovaReserva: "Nova reserva",
   isReservaCancelada: "Reserva cancelada",
   isArtigosFavoritos: "Artigos favoritos",
   isDoacaoCancelada: "Doação cancelada",
   isProximo: "Notificações de proximidade",
   isNewAlternativeDonation: "Nova doação para alimentação animal",
   IsEntidadeBeneficiaria: "Doações atribuídas"
};
